import React, {useState} from 'react';
import {
  View,
  FlatList,
  TextInput,
  TouchableOpacity,
  Pressable,
  Platform,
} from 'react-native';

import Text from '../../elements/Text';
import FilterResourceModal from '../FilterResourceModal';
import FilterProductsModal from '../FilterProductsModal';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';
import {FILTER_TYPE} from '../../../utils/Constants';
import CommonStyles from '../../../utils/CommonStyles';
import {tID} from '../../../utils/TestIdHelper';
import {CloseIcon, FilterIcon} from '../../../utils/SvgIcons';

const SearchFilterView = ({
  tags = [],
  searchTerm,
  setSearchTerm,
  selectedFilters,
  setSelectedFilters,
  type = FILTER_TYPE.resource,
  placeholder = 'Search...',
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const [visibleFilter, setVisibleFilter] = useState(false);

  const onCloseFilterView = () => {
    setVisibleFilter(false);
  };

  const onPressFilter = () => {
    setVisibleFilter(true);
  };

  const onPressRemoveSearch = () => {
    setSearchTerm('');
  };

  const onPressApplyFilter = filter => {
    setSelectedFilters(filter);
    onCloseFilterView();
  };

  const onPressResetFilter = () => {
    onCloseFilterView();
    setSelectedFilters([]);
  };

  const onPressRemoveFilter = idx => {
    let filters = [...selectedFilters];
    const _ = filters.splice(idx, 1);
    setSelectedFilters(filters);
  };

  const renderSelectedFilterTags = () => {
    if (type == FILTER_TYPE.resource) {
      return (
        <FlatList
          testID={tID('SearchFilterView-FlatList-Tags')}
          horizontal
          showsHorizontalScrollIndicator={false}
          data={selectedFilters}
          renderItem={renderTags}
          keyExtractor={(item, index) => index}
          showsVerticalScrollIndicator={false}
          style={styles.marginTop16}
        />
      );
    } else {
      return null;
    }
  };

  const renderTags = ({item, index}) => {
    const tagTestIdIndex = index + 1;
    return (
      <View
        testID={tID(`SearchFilterView-View-Tag${tagTestIdIndex}`)}
        style={styles.tagContainer(index)}>
        <Text
          testID={tID(`SearchFilterView-Text-TagName${tagTestIdIndex}`)}
          variation={'Text1SemiBold'}
          color={colors.link}>
          {item.name}
        </Text>
        <Pressable
          testID={tID(`SearchFilterView-Pressable-TagRemove${tagTestIdIndex}`)}
          hitSlop={styles.hitSlop}
          onPress={() => onPressRemoveFilter(index)}>
          <CloseIcon
            testID={tID(`SearchFilterView-Image-TagRemove${tagTestIdIndex}`)}
            height={12}
            width={12}
            tintColor={colors.textDisabled}
            style={CommonStyles.ml_16}
          />
        </Pressable>
      </View>
    );
  };

  return (
    <>
      <View testID={tID('SearchFilterView-View-Main')} style={styles.container}>
        <View
          testID={tID('SearchFilterView-View-Search')}
          style={styles.searchContainer}>
          <TextInput
            testID={tID('SearchFilterView-Input-Search')}
            style={[
              styles.searchInput,
              Platform.OS === 'web' && CommonStyles.oulinewidth_0,
            ]}
            placeholder={placeholder}
            placeholderTextColor={colors.textMuted}
            value={searchTerm}
            onChangeText={setSearchTerm}
          />
          {searchTerm.length > 0 && (
            <TouchableOpacity
              testID={tID('SearchFilterView-TouchableOpacity-Close')}
              activeOpacity={0.6}
              style={styles.closeButtonContainer}
              onPress={onPressRemoveSearch}>
              <CloseIcon
                testID={tID('SearchFilterView-Image-Close')}
                height={12}
                width={12}
                tintColor={colors.textDisabled}
              />
            </TouchableOpacity>
          )}
        </View>
        <TouchableOpacity
          testID={tID('SearchFilterView-TouchableOpacity-Filter')}
          activeOpacity={0.6}
          style={styles.filterButtonContainer}
          onPress={onPressFilter}>
          <FilterIcon testID={tID('SearchFilterView-Image-Filter')} />
        </TouchableOpacity>
      </View>
      {selectedFilters.length > 0 && renderSelectedFilterTags()}
      {type == FILTER_TYPE.resource && (
        <FilterResourceModal
          visible={visibleFilter}
          tags={tags}
          selectedFilters={selectedFilters}
          onClose={onCloseFilterView}
          onApplyFilter={onPressApplyFilter}
          onResetFilter={onPressResetFilter}
        />
      )}
      {type == FILTER_TYPE.product && (
        <FilterProductsModal
          visible={visibleFilter}
          selectedFilters={selectedFilters}
          onClose={onCloseFilterView}
          onApplyFilter={onPressApplyFilter}
          onResetFilter={onPressResetFilter}
        />
      )}
    </>
  );
};

export default SearchFilterView;
